<template>
  <!--
    No BlockFieldset at the root: it would also disable the card headers, so readers could not open
    a card. AccordionCard disables only its body.
  -->
  <div class="project-measurement-report-data">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <template v-else>
      <MobileProjectsMeasurement
        :project="project"
        :saveCard="saveCard"
        :reportTemplateImages="project.reportTemplateImages"
        :bricks="project.bricks"
      />
      <ProjectReportVerificationRequest :project="project" :protocol="protocol" />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MobileProjectsMeasurement from '@/views/Projects/MobileProjectsMeasurement';
import ProjectReportVerificationRequest from '@/blocks/project/report/ProjectReportVerificationRequest';

/** Number of the unsaved project (ProjectEdit `_new`). */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-measurement-report-data ("Aufmaßprotokoll: Erfasste Daten", see feature page
 * projekt-protokolle): the cards, saved per card with "weiter"/"zurück" and the card state toggle,
 * with their photos and the customer signature; below them the section "4. Prüfung" with the AC and DC
 * states and a request button per side (the block project-measurement-report-verification requests
 * too, see feature page projekt-protokolle). `project` is the block data
 * (`Project.blocks.measurementReportData`) with the reference data of the cards.
 */
export default {
  name: 'ProjectMeasurementReportData',
  components: { ProjectReportVerificationRequest, MobileProjectsMeasurement },
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
    /** Config of the protocol (`reportProtocols.js`), passed by the tab; not imported here (cycle). */
    protocol: { type: Object, required: true },
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectMeasurementReportData']),
    saveCard(input) {
      return this.updateProjectMeasurementReportData({ projectNumber: this.project.number, input });
    },
  },
};
</script>
